import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';


import { NgxPermissionsGuard } from 'ngx-permissions';
import { AgmCoreModule } from '@agm/core';
import { environment } from '../../../../../../environments/environment';
import { StudentService } from '../../../../services/students/student.service';
import { PersonGenderService } from '../../../../services/person-genders/person-gender.service';
import { DivisionService } from '../../../../services/divisions/division.service';
import { RelationshipService } from '../../../../services/relationships/relationship.service';
import { TutorService } from '../../../../services/tutors/tutor.service';
import { ReportService } from '../../../../services/reports/report.service';
import { LightboxModule } from 'ngx-lightbox';
import { NoticiasComponent } from './noticias.component';
import { AddNoticiaComponent } from './components/add-noticia/add-noticia.component';
import { SharedModule } from '../../../../../core/modules/shared.module';
import { FuseWidgetModule } from '../../../../../core/components/widget/widget.module';
import { NoticiasService } from '../../../../services/noticias/noticias.service';
import { NgxEditorModule } from 'ngx-editor';
import { ConfigService } from './components/add-noticia/config.service';
import { TipoNoticiasService } from '../../../../services/tipo-noticias/tipo-noticia.service';
import { RichTextEditorAllModule } from '@syncfusion/ej2-angular-richtexteditor';
import { AddMenuComponent } from './components/add-menu/add-menu.component';
import { FormsModule } from '@angular/forms';


const routes = [
    {
        path: 'pages/management/subjects/:id',
        component: NoticiasComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
            permissions: {
                only: 'PAGES_MANAGEMENT_NEWS',
                redirectTo: '/pages/errors/error-403'
            }
        }
    },
    {
        path: 'pages/management/noticias',
        component: NoticiasComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
            permissions: {
                only: 'PAGES_MANAGEMENT_NEWS',
                redirectTo: '/pages/errors/error-403'
            }
        }
    }
];

@NgModule({
    declarations: [
        NoticiasComponent,
        AddNoticiaComponent,
        AddMenuComponent
    ],
    imports: [
        SharedModule,
        RouterModule.forChild(routes),
        FuseWidgetModule,
        LightboxModule,
        AgmCoreModule.forRoot({
            apiKey: environment.googleMapsApiKey
        }),
        NgxEditorModule,
        RichTextEditorAllModule,
        FormsModule
    ],
    exports: [
        NoticiasComponent,
    ],
    entryComponents: [
        AddNoticiaComponent,
        AddMenuComponent
    ],
    providers: [
        StudentService,
        PersonGenderService,
        DivisionService,
        RelationshipService,
        TutorService,
        ReportService,
        NoticiasService,
        ConfigService,
        TipoNoticiasService
    ]
})

export class NoticiasModule {
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/noticias/noticias.module.ts